function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 100 76",
  preserveAspectRatio: "xMidYMid"
}, props), React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "100%",
  y1: "0%",
  x2: "0%",
  y2: "100%",
  id: "a"
}, React.createElement("stop", {
  stopColor: "#F3D08F",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAD766",
  offset: "100%"
}))), React.createElement("path", {
  d: "M92.727 75.455H7.272c-4 0-7.273-3.273-7.273-7.273V7.273c0-4 3.273-7.273 7.273-7.273h85.455c4 0 7.273 3.273 7.273 7.273v60.909c0 4-3.273 7.273-7.273 7.273",
  fill: "url(#a)"
}), React.createElement("path", {
  d: "M72.123 28.485h27.878v-1.818H70.353c-.965 0-1.832.601-2.172 1.504-2.287 6.072-2.433 12.594-.438 19.842a8.705 8.705 0 01-.1 5.03c-2.036 6.195-7.779 19.988-18.551 19.988-11.008 0-16.096-15.699-17.334-21.952a4.899 4.899 0 01.107-2.357c1.695-5.648 2.094-10.64-.016-19.59a5.448 5.448 0 01.048-2.646C36.377 9.731 44.779 6.339 44.862 6.307a.91.91 0 00.593-.852V0h-1.818v3.776c0 .65-.332 1.252-.884 1.596-2.803 1.742-8.904 6.936-12.557 20.456a1.522 1.522 0 01-1.473 1.133L.001 26.822v1.818l27.416.133a3.122 3.122 0 013.037 2.478c1.416 6.741 1.219 11.039.082 15.458a2.809 2.809 0 01-2.69 2.109l-27.844.27v1.819l28.605-.278a1.445 1.445 0 011.435 1.152c1.442 7.041 6.887 23.07 19.05 23.07 6.368 0 12.062-4.25 16.467-12.29 2.644-4.828 4.067-9.591 4.541-11.346h29.901v-1.818H71.985a2.58 2.58 0 01-2.489-1.889c-1.692-6.164-1.761-11.755-.2-16.959.371-1.235 1.538-2.061 2.827-2.061zM54.973 6.571c.045.022 4.519 2.322 9.253 10.041a.909.909 0 001.347.232c.365-.292.416-.837.172-1.235-3.57-5.805-7.024-8.71-8.775-9.931a1.598 1.598 0 01-.68-1.315V0h-1.818v5.758a.91.91 0 00.502.813z",
  fill: "#0C0200"
})));